const URL_API = "https://backoffice.virtex.com.br"; // 'http://177.66.118.71:8085';
// const URL_API_RHX = "https://apirhx.virtex.com.br/api";
const URL_API_RHX = "https://backoffice.virtex.com.br:444/curriculos";
// const URL_API_RHX = "http://localhost:8087/api";
export const STATIC_API = `/data.json`;
export const API_GEO_IP = ip =>
  `http://api.ipstack.com/${ip}?access_key=f05b50c0ab39976c9d20d5f3bde8b67d`;
export const API_IP = `${URL_API}/api/ip`;
export const API_NOTICIAS = `${URL_API}/api/noticias`;
export const API_PLANOS = `${URL_API}/api/planos`;
export const API_FAQ = `${URL_API}/api/perguntas_frequentes`;
export const API_TRABALHE_CONOSCO_RHX = {
  cadastrar: `${URL_API_RHX}/curriculo`,
  verificarCPF: `${URL_API_RHX}/candidato/validarCPF`,
  recuperar: `${URL_API_RHX}/candidato/recuperar`,
  cidades: `${URL_API_RHX}/cidades`,
  setores: `${URL_API_RHX}/curriculo/setor`,
  perguntas: `${URL_API_RHX}/curriculo/pergunta`,
  escolaridade: `${URL_API_RHX}/curriculo/escolaridades`,
  estadosCivis: `${URL_API_RHX}/curriculo/estadosCivis`,
  redesSociais: `${URL_API_RHX}/redesocial`,
  faixaSalarial: `${URL_API_RHX}/curriculo/faixaSalarial`,
  validarToken: `${URL_API_RHX}/candidato/validar/`,
  detalhar: `${URL_API_RHX}/curriculo/`
};

const LIGAR_ME_URL = "http://177.66.118.71:5004";

export const LIGAR_ME_CAPTCHA = `${LIGAR_ME_URL}/captcha.svg`;
export const LIGAR_ME = `${LIGAR_ME_URL}/ligar`;
